import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FiChecklist2ReportType } from '../../../enums/fi-checklist2-report-type';
import { FiChecklist2ReportHelperService } from '../../../services/fi-checklist2-report-helper.service';
import { IChecklistV2ReportParameter } from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-widget-details-header',
    templateUrl: './checklist-report-widget-details-header.component.html',
    styleUrls: ['./checklist-report-widget-details-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-widget-details-header' },
    standalone: false,
})
export class FiChecklist2ReportWidgetDetailsHeader implements OnInit, OnDestroy {
    @Input({ required: true }) reportParameter: IChecklistV2ReportParameter;
    @Input() checklistReportType: FiChecklist2ReportType;
    protected filterButtonsVisibilityStatus$ = new BehaviorSubject<boolean>(false);

    constructor(
        private fiChecklist2ReportHelperService: FiChecklist2ReportHelperService,
        private appTextService: AppTextService,
    ) {}

    public ngOnInit(): void {
        this.subscribeOnFilterButtonsVisibilityChange();
    }

    private subscribeOnFilterButtonsVisibilityChange(): void {
        this.fiChecklist2ReportHelperService
            .onSaveFilterButtonVisibilityChange$()
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe((isVisible: boolean) => this.filterButtonsVisibilityStatus$.next(isVisible));
    }

    protected getChecklistWidgetName(): string {
        return this.fiChecklist2ReportHelperService.isCustomReportWidget(this.reportParameter)
            ? this.reportParameter.Name
            : this.fiChecklist2ReportHelperService.getChecklistReportSectionNameByType(this.reportParameter.ReportType);
    }

    protected navigateToDashboard(): void {
        this.fiChecklist2ReportHelperService.triggerNavigateToDashboard();
    }

    protected saveFilterAsNewWidget(): void {
        this.fiChecklist2ReportHelperService.saveFilterAsNewWidget();
    }

    protected saveFilter(): void {
        this.fiChecklist2ReportHelperService.saveFilter({
            updateCurrentFilter: this.fiChecklist2ReportHelperService.isCustomReportWidget(this.reportParameter),
        });
    }

    protected getSaveFilterLabel(): string {
        const isCustomReportWidget = this.fiChecklist2ReportHelperService.isCustomReportWidget(this.reportParameter);
        return this.appTextService.get(isCustomReportWidget ? 'common.update_widget' : 'save_filter');
    }

    protected toggleFilterContainerVisibility(): void {
        this.fiChecklist2ReportHelperService.toggleWidgetDetailsFilterContainerVisibility();
    }

    private ngOnDestroy$ = new Subject<void>();
    public ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
